/**
 * @项目名称: work
 * @功能名称:
 * @文件名称: reportElement
 * @Date: 2019/12/5
 * @Author: liux
 * @Copyright（C）2019 「小赢科技」 Inc.   All rights reserved.
 * 注意：本内容仅限于「小赢科技」内部传阅，禁止外泄以及用于其他的商业目的。
 */
import Vue from 'vue'

function getEvents(binding) {
  var events = Object.keys(binding.modifiers)
  if(events.length === 0){
    events = ['click']
  }
  return events
}
function setValue (el, binding) {
  var events = getEvents(binding)
  var key = '_xreportData' + events[0];
  var value = typeof binding.value === 'object'? binding.value : {}
  el[key] = value;
}
export default function (report) {
  Vue.directive('xreport', {
    inserted (el, binding) {
      var events = getEvents(binding)
      var key = '_xreportData' + events[0];
      setValue(el, binding)
      events.forEach((event) => {
        // 非img,iframe dom load事件立即上报
        if (event === 'load' && ['IMG', 'IFRAME'].indexOf(el.nodeName) === -1) {
          report.reportElement({
            ...el[key],
            element: el
          },
            binding.arg === 'cache',
            binding.modifiers.noExtendEventName
            )
        } else {
          el.addEventListener(event, function () {
            report.reportElement({
              ...el[key],
              element: el
            },
              binding.arg === 'cache',
              binding.modifiers.noExtendEventName)
          },true)
        }
      })
    },
    update (el, binding) {
      setValue(el, binding)
    },
    unbind (el, binding) {
      var events = getEvents(binding)
      el['_xreportData' + events[0]] = null
    }
  })
}
